/* eslint-disable */
import React, { useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import { CreateUser } from 'src/services/UserService';
import Validation from 'src/utils/validation';
import useAppMutation from 'src/hooks/useAppMutation';
import { COLOR_3 } from 'src/constants/ChartConstant';
import ValidateOTPModal from './modal/validate-otp-modal';
import Utils from 'src/utils';
import getErrorMessage from 'src/utils/getError';
import useAppSearchParams from 'src/hooks/useAppSearchParams';

interface SNBLRegisterFormProps {}

export const SNBLRegisterForm: React.FC<SNBLRegisterFormProps> = () => {
  const [form] = Form.useForm<CreateUser>();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { addSearchParam } = useAppSearchParams();

  const { error, isPending, data, mutate } = useAppMutation<CreateUser, { userId: string }>('/users/v1/self/user', {
    onSuccess: (data) => {
      setModalOpen(true);
      addSearchParam('userId', data.userId);
    },
  });

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const phoneNumber = Utils.convertPhoneToISO(values.phoneNumber);
        setPhoneNumber(phoneNumber);
        mutate({ ...values, phoneNumber, registrationType: 'CUSTOMER' });
      })
      .catch((info) => {
        message.error('Validation Failed:', info);
      });
  };

  return (
    <Form form={form} layout="vertical" name="snbl-form" onFinish={onSubmit} className="w-100">
      <Form.Item hasFeedback name="firstName" label="First name" rules={Validation.antFormRules.firstName}>
        <Input placeholder="First name" />
      </Form.Item>
      <Form.Item hasFeedback name="lastName" label="Last name" rules={Validation.antFormRules.lastName}>
        <Input placeholder="Last name" />
      </Form.Item>
      <Form.Item hasFeedback name="phoneNumber" label="Phone number" rules={Validation.antFormRules.phoneNumber}>
        <Input placeholder="Phone number" maxLength={11} />
      </Form.Item>
      <Button loading={isPending} htmlType="submit">
        Submit
      </Button>
      <p style={{ color: COLOR_3 }}>{error && getErrorMessage(error)}</p>
      <ValidateOTPModal phoneNumber={phoneNumber as string} modalProps={{ visible: modalOpen, onCancel: () => setModalOpen(false) }} />
    </Form>
  );
};
